import { useMutation, useQueryClient } from "@tanstack/react-query";
import { API } from "../API";
import { VisitInstanceId } from "../messages";

type Params = {
  api: Pick<API, "withdrawPayment">;
};

const useWithdrawPayment = (params: Params) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (visitInstanceIds: VisitInstanceId[]) =>
      params.api.withdrawPayment({ eligibleVisitInstanceIds: visitInstanceIds }),
    onSuccess: () => queryClient.invalidateQueries(["instapay", "overview"]),
  });
};

export default useWithdrawPayment;
